import { render, staticRenderFns } from "./NovoClubeDistrito.vue?vue&type=template&id=710d20c0&scoped=true"
import script from "./NovoClubeDistrito.vue?vue&type=script&lang=ts"
export * from "./NovoClubeDistrito.vue?vue&type=script&lang=ts"
import style0 from "./NovoClubeDistrito.vue?vue&type=style&index=0&id=710d20c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710d20c0",
  null
  
)

export default component.exports